import Container from "@src/components/container"
import OriginalCard from "@src/components/originalCard"
import ResponsiveContent from "@src/components/responsiveContent"
import Title from "@src/components/title"
import { parseGapiData, requestGapi } from "@src/utils/request"
import React, { useCallback, useEffect, useState } from "react"
import * as styles from "./head.module.scss"
import firstVideo from "@images/header.mp4"
import bgVideo from "@imagesgz/loop.mp4"
import loopImg from "@imagesgz/loop.png"
import mobileHeadImg from "@imagesgz/head-app.jpg"
import classnames from "@src/utils/classnames"

const relativeTagId = "24921"

const wxReadyEvent = event => {
  if (typeof window.WeixinJSBridge === "undefined") {
    document.addEventListener(
      "WeixinJSBridgeReady",
      () => {
        event()
      },
      false
    )
  } else {
    window.WeixinJSBridge.invoke(
      "getNetworkType",
      {},
      function(e) {
        event()
      },
      false
    )
  }
}

const Head = () => {
  const [data, setData] = useState(null)
  const [hideFirstVideo, setHideFirstVideo] = useState(false)
  const bgVideoRef = useCallback(bgVideo => {
    if (!bgVideo) return

    const play = () => {
      if (bgVideo) {
        bgVideo.play()
      }
    }
    play()
    wxReadyEvent(play)
  }, [])
  const firstVideoRef = useCallback(video => {
    if (!video) return

    const play = () => {
      if (video) {
        video.play()
      }
    }
    play()
    wxReadyEvent(play)
    video.onended = () => {
      setHideFirstVideo(true)
    }
  }, [])

  useEffect(() => {
    const request = async () => {
      const res = await requestGapi(
        `/tags/${relativeTagId}/originals?include=user&sort=-published-at`
      )
      setData(parseGapiData(res))
    }
    void request()
  }, [])
  return (
    <>
      <ResponsiveContent
        mobile={() => {
          return (
            <div className={styles.appHead}>
              <img src={mobileHeadImg} alt="" />
              {/* <Container>
                <div className={styles.mobileVideo}>
                  <div>
                    <iframe
                      title="宣传视频"
                      allowFullScreen
                      frameborder="0"
                      framespacing="0"
                      border="0"
                      src="https://www.taptap.com/video/2163190/embed?thumb=https%3A%2F%2Fimg2.tapimg.com%2Fbbcode%2Fimages%2Fb4190a33fcb08c3f3a1520392e43a1fc.jpg%3FimageView2%2F0%2Fw%2F1080%2Fh%2F9999%2Fq%2F80%2Fformat%2Fjpg%2Finterlace%2F1%2Fignore-error%2F1"
                    />
                  </div>
                </div>
              </Container> */}
            </div>
          )
        }}
      >
        <div className={styles.head}>
          <div>
            {/* <img src={loopImg} /> */}
            <video
              ref={bgVideoRef}
              muted
              autoPlay
              loop="loop"
              playsInline
              x5-video-player-type="h5"
            >
              <source src={bgVideo} type="video/mp4" />
            </video>
          </div>
          {/* <div
            className={classnames({
              [styles.is_hide]: hideFirstVideo,
            })}
          >
            <video
              ref={firstVideoRef}
              muted
              autoPlay
              playsInline
              x5-video-player-type="h5"
            >
              <source src={firstVideo} type="video/mp4" />
            </video>
          </div> */}
        </div>
      </ResponsiveContent>
      <div className={styles.news}>
        <Container id="news">
          <Title
            moreProps={{
              appNavTo: `https://www.gcores.com/tags/${relativeTagId}`,
            }}
            moreText="更多>"
          >
            最新消息
          </Title>
          <div className={styles.newsList}>
            {data &&
              data
                .slice(0, 3)
                .map(item => (
                  <OriginalCard
                    type={item.type}
                    id={item.id}
                    key={item.id}
                    title={item.attributes.title}
                    category="官方活动"
                    thumb={`https://image.gcores.com/${item.attributes.thumb}?x-oss-process=image/resize,limit_1,m_fill,w_626,h_292/quality,q_90`}
                    userName={item.rels.user.attributes.nickname}
                    userThumb={`https://image.gcores.com/${item.rels.user.attributes.thumb}?x-oss-process=image/resize,limit_1,m_fill,w_52,h_52/quality,q_90/bright,-20`}
                    date={new Date(
                      item.attributes["published-at"]
                    ).toLocaleDateString()}
                  />
                ))}
          </div>
        </Container>
      </div>
    </>
  )
}

export default Head
